import { usePrevious, useUpdateEffect } from 'react-use';

import {
   EmergencyNotificationTestTriggerCommand,
   EmergencyNotificationTriggerCommand,
} from '@dreryk/egabinet-emergency-notification-frontend-api';
import { VisitId } from '@dreryk/egabinet-visit-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { translationKeys } from '../translations';

import { useEmergencyNotification } from './useEmergencyNotification';

export const EmergencyNotificationTrigger = (): null => {
   const { state, context, cancel, setNotificationIdForEmergencyNotification } = useEmergencyNotification();
   const previousType = usePrevious(state.type);

   const { executeAsync: triggerEmergencyNotification } = useCqrsCommand<number, void>(() => {
      const command = new EmergencyNotificationTriggerCommand();
      if (context.visitId) {
         command.visitId = Slot.of(VisitId.of(context.visitId));
      }
      return command;
   });

   const { executeAsync: triggerTestEmergencyNotification } = useCqrsCommand<number, void>(() => {
      return new EmergencyNotificationTestTriggerCommand();
   });

   useUpdateEffect(() => {
      const shouldTrigger = previousType === 'idle' && state.type === 'active';
      if (shouldTrigger) {
         const executor = state.variant === 'real' ? triggerEmergencyNotification : triggerTestEmergencyNotification;
         executor()
            .then(setNotificationIdForEmergencyNotification)
            .catch(() => {
               dispatchSnackbarNegativeEvent(translationKeys.sosFailedToTrigger);
               cancel();
            });
      }
   }, [state.type]);

   return null;
};
